"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _View = _interopRequireDefault(require("react-native-web/dist/cjs/exports/View"));
var _utils = require("../utils");
var _ProductCard = _interopRequireDefault(require("../ProductCard"));
var _StackView = require("../StackView");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const [selectProps, selectedSystemPropTypes] = (0, _utils.selectSystemProps)([_utils.htmlAttrs, _utils.viewProps, _utils.a11yProps]);
const ProductCardGroup = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    productCards,
    maxSelection = 1,
    ...rest
  } = _ref;
  const [selectedCardIds, setSelectedCardIds] = _react.default.useState([]);
  const handleSelect = id => {
    const isAlreadySelected = selectedCardIds.includes(id);
    let updatedSelectedCardIds;
    if (isAlreadySelected) {
      updatedSelectedCardIds = selectedCardIds.filter(cardId => cardId !== id);
    } else if (maxSelection && selectedCardIds.length >= maxSelection) {
      updatedSelectedCardIds = selectedCardIds.filter((_, index) => index !== 0).concat(id);
    } else {
      updatedSelectedCardIds = [...selectedCardIds, id];
    }
    setSelectedCardIds(updatedSelectedCardIds);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
    ...selectProps(rest),
    ref: ref,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_StackView.StackWrap, {
      direction: {
        xs: 'column',
        lg: 'row'
      },
      space: 4,
      children: productCards.map((cardProperties, index) => {
        const cardId = cardProperties.id || index;
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProductCard.default, {
            cardId: cardId,
            isSelected: selectedCardIds.includes(cardId),
            onSelect: handleSelect,
            ...cardProperties
          }, cardId)
        }, cardId);
      })
    })
  });
});
ProductCardGroup.displayName = 'ProductCardGroup';
ProductCardGroup.propTypes = {
  ...selectedSystemPropTypes,
  /**
   * The maximum number of ProductCards a user may select at once. Defaults to 1.
   * To have no limit and allow any number of selections, pass `null`.
   */
  maxSelection: _propTypes.default.number,
  /**
   * Props to be passed to the `ProductCard` component.
   * id is required for each card.
   * You may also pass in a custom dictionary object.
   */
  productCards: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    image: _propTypes.default.object,
    dictionary: _propTypes.default.object
  })).isRequired
};
var _default = exports.default = ProductCardGroup;